import React, { Component } from 'react';
import { Field, reduxForm, initialize } from 'redux-form';
import { connect } from 'react-redux';
import {
    Form,
    Col,
    Row,
    FormGroup,
    FormControl
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';

import Link from '../../Link';
import Loader from '../../Common/Loader';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';

import bt from '../../../components/commonStyle.css';
import s from './AddCancelReasonForm.css';

export class AddCancelReasonForm extends Component {
    static defaultProps = {
        loading: false
    };
    componentDidMount() {
        const { initialize, initialValues } = this.props;
        if (initialValues && initialValues.id) {
            initialize({
                id: initialValues && initialValues.id,
                userType: initialValues && initialValues.userType,
                reason: initialValues && initialValues.reason,
                isActive: initialValues && initialValues.isActive == 0 ? 0 : 1
            })
        } else {

            initialize({ userType: 1, isActive: 1 })
        }
    }

    render() {
        const { handleSubmit, initialValues, loading, submitting } = this.props;
        const id = initialValues && initialValues.id
        const { formatMessage } = this.props.intl;
        const userTypeOptions = [
            { value: 1, label: formatMessage(messages.user) },
            { value: 2, label: formatMessage(messages.partner) }
        ]
        const isActiveOptions = [
            { value: "1", label: formatMessage(messages.active) },
            { value: "0", label: formatMessage(messages.inactive) }
        ]
        return (
            <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                <h1 className='siteAdminPrimaryHeading'>{id ? formatMessage(messages.editCancelReason) : formatMessage(messages.addCancelReason)}</h1>
                <div className='oneColumnGrid'>
                    <Field
                        name="reason"
                        type="text"
                        placeholder={formatMessage(messages.reason)}
                        component={InputFieldComponent}
                        componentClass="textarea"
                        label={formatMessage(messages.reason)}
                        inputClass={bt.formTextArea}
                    />
                    <div className='twoColumnGrid'>
                        <Field
                            name="userType"
                            label={formatMessage(messages.cancelledBy)}
                            options={userTypeOptions}
                            inputClass={bt.formControlSelect}
                            component={SelectFieldComponent}
                        />

                        <Field
                            name="isActive"
                            label={formatMessage(messages.status)}
                            inputClass={bt.formControlSelect}
                            component={SelectFieldComponent}
                            options={isActiveOptions}
                        />
                    </div>
                </div>
                <div className='commonButtonContainer'>
                    <Link to={"/siteadmin/cancel-reasons"} className={bt.btnSecondary}>{formatMessage(messages.goBack)}</Link>
                    <Loader
                        type={"button"}
                        label={formatMessage(messages.submitButton)}
                        show={loading}
                        buttonType={'submit'}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                        disabled={submitting || loading}
                    />
                </div>
            </Form>
        )
    }
}
AddCancelReasonForm = reduxForm({
    form: 'AddCancelReasonForm',
    onSubmit: submit,
    validate
})(AddCancelReasonForm);
const mapState = (state) => ({
    loading: state.loader.AddCancellation
})

const mapDispatch = {
    initialize
}
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AddCancelReasonForm)));